//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.OperationBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
import "../CAM/CAM.CutParameters.js";
import "../CAM/CAM.FeedsBuilder.js";
let d=[[[0,"AllowOversizeTool",1,0],[1,"BlindHoleStockBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"CheckFluteLength",1,0],[0,"CheckToolLength",1,0],[1,"ClrDistBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"ClrVertBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"ControlPointType",1,0],[1,"CutParameters",0,"CAM.CutParameters",0],[0,"EngageFeedRate",1,0],[1,"FeedsBuilder",0,"CAM.FeedsBuilder",0],[0,"ModelDepthType",1,0],[1,"OversizeToolPercentBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"RapidFeedRate",1,0],[1,"RaptoOffsetBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"RaptoOffsetToggle",1,0],[1,"ThruClearBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"ToolAxisType",1,0],[0,"ToolAxisVector",1,"NXObject",0],[0,"UseQuery",1,0],[0,"UseUserDefinedTp",1,0]],[],[]];
SPLM.CAM.HoleMakingBuilder = class extends SPLM.CAM.OperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.HoleMakingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.HoleMakingBuilder.ControlPointTypes = Object.freeze({
    "ToolTip" : "ToolTip", "Shoulder" : "Shoulder"});

SPLM.CAM.HoleMakingBuilder.ModelDepthTypes = Object.freeze({
    "Always" : "Always", "Rule" : "Rule"});

SPLM.CAM.HoleMakingBuilder.ToolAxisTypes = Object.freeze({
    "PositiveZOfMcs" : "PositiveZOfMcs", "FixedAxis" : "FixedAxis", "AllAxes" : "AllAxes"});

export default SPLM;